import React, { useState, useEffect } from 'react';
import './Nav.css';
import { AiOutlineHome, AiOutlineUser, AiOutlineStar } from "react-icons/ai";
import { BiBook, BiBriefcase, BiMessageSquareDetail } from "react-icons/bi";
import { RiServiceLine } from "react-icons/ri";

const NAV_ITEMS = [
  { id: 'home', icon: <AiOutlineHome />, label: 'Home' },
  { id: 'about', icon: <AiOutlineUser />, label: 'About' },
  { id: 'experience', icon: <BiBook />, label: 'Experience' },
  { id: 'services', icon: <RiServiceLine />, label: 'Services' },
  { id: 'portfolio', icon: <BiBriefcase />, label: 'Portfolio' },
  { id: 'testimonials', icon: <AiOutlineStar />, label: 'Testimonials' },
  { id: 'contact', icon: <BiMessageSquareDetail />, label: 'Contact' },
];

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#home');

  // Scroll-spy: highlight the nav icon for whichever section is centered in the viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveNav(`#${entry.target.id}`);
        });
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
    );

    NAV_ITEMS.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <nav>
      {NAV_ITEMS.map(({ id, icon, label }) => (
        <a
          key={id}
          href={`#${id}`}
          onClick={() => setActiveNav(`#${id}`)}
          className={activeNav === `#${id}` ? 'active' : ''}
          title={label}
          aria-label={label}
        >
          {icon}
        </a>
      ))}
    </nav>
  );
};

export default Nav;
